import { createContext, useContext } from 'react'
import type { Map as MlMap } from 'maplibre-gl'

/** The live map for tools drawn on top of it. Kept apart from MapView so that a screen importing the tool does not pull the whole map library into
 *  the main bundle: MapView (and maplibre with it) is loaded only when a map screen opens. */
export const MapCtx = createContext<MlMap | null>(null)
export const useMapInstance = () => useContext(MapCtx)
